
export default {
  selectChoiceList: { // 찜 리스트
    method: 'GET',
    url: 'mrm/v1/permit/nrw/mySpace/selectChoiceList'
  }
}



// WEBPACK FOOTER //
// ./src/config/router/nrw/api/choiceApi.js